import { render, staticRenderFns } from "./secondarycontent.vue?vue&type=template&id=0e04be24&scoped=true"
import script from "./secondarycontent.vue?vue&type=script&lang=js"
export * from "./secondarycontent.vue?vue&type=script&lang=js"
import style0 from "./secondarycontent.vue?vue&type=style&index=0&id=0e04be24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e04be24",
  null
  
)

export default component.exports